import React from 'react';
import PropTypes from 'prop-types';
import { snakeCaseKeys, toQueryString } from '@lib/utils';

const SimilarVehiclesCta = ({ makeModelTrim }) => {
  const buildQueryString = (makeModelTrim) => {
    if (!makeModelTrim) {
      return '/vehicles';
    }

    const model = makeModelTrim['model'] ? makeModelTrim['model'] : '_all';
    const trim = { [makeModelTrim['model']]: [makeModelTrim['trim']] };

    const queryObject = {
      [makeModelTrim['make']]: [makeModelTrim['trim'] ? trim : model],
    };
    const queryString = toQueryString(
      snakeCaseKeys({ makeModel: { ...queryObject } }),
    );

    return `/vehicles?${queryString}`;
  };

  return (
    <a
      className="ch-btn ch-width--12"
      href={buildQueryString(makeModelTrim)}
      rel="nofollow"
    >
      Search for {makeModelTrim ? 'similar vehicles' : 'another vehicle'}
    </a>
  );
};

SimilarVehiclesCta.propTypes = {
  makeModelTrim: PropTypes.object,
};

export default SimilarVehiclesCta;
